<!-- ═══ HEADER ═══ -->
<div class="hp-header">
  <div class="hp-header-left">
    <button nz-button nzType="text" (click)="geriDon()" nz-tooltip nzTooltipTitle="Panoya Dön">
      <span nz-icon nzType="arrow-left"></span>
    </button>
    <h2 class="hp-title">Personeller</h2>
    <span class="hp-subtitle">{{ toplam() }} kayıt</span>
  </div>
  <div class="hp-header-right">
    <nz-input-wrapper [nzPrefix]="aramaRef" class="hp-search">
      <input nz-input placeholder="Ad, soyad ara..."
             [ngModel]="aramaMetni"
             (ngModelChange)="aramaMetniDegisti($event)" />
    </nz-input-wrapper>
    <ng-template #aramaRef>
      <span nz-icon nzType="search" style="color:#bfbfbf"></span>
    </ng-template>

    <nz-select class="hp-dept-select"
               [(ngModel)]="seciliDepartmanId"
               (ngModelChange)="yukle()"
               nzPlaceHolder="Tüm Departmanlar"
               nzAllowClear
               [nzDropdownMatchSelectWidth]="false">
      @for (d of departmanlar(); track d._id) {
        <nz-option [nzValue]="d._id" [nzLabel]="d.departmanAdi" />
      }
    </nz-select>

    <button nz-button nzType="default" (click)="yukle()" nz-tooltip nzTooltipTitle="Yenile"
            [nzLoading]="yukleniyor()">
      <span nz-icon nzType="reload"></span>
    </button>

    <button nz-button nzType="primary" (click)="yeniPersonelAc()">
      <span nz-icon nzType="user-add"></span>
      Yeni Personel
    </button>
  </div>
</div>

<!-- ═══ İSTATİSTİKLER ═══ -->
<div class="hp-stats">
  <div class="hp-stat">
    <span nz-icon nzType="team" class="hp-stat-icon blue"></span>
    <div class="hp-stat-body">
      <div class="hp-stat-val">{{ istatistikler().toplam }}</div>
      <div class="hp-stat-lbl">Toplam</div>
    </div>
  </div>
  <div class="hp-stat">
    <span nz-icon nzType="check-circle" class="hp-stat-icon green"></span>
    <div class="hp-stat-body">
      <div class="hp-stat-val">{{ istatistikler().aktif }}</div>
      <div class="hp-stat-lbl">Aktif</div>
    </div>
  </div>
  <div class="hp-stat">
    <span nz-icon nzType="credit-card" class="hp-stat-icon cyan"></span>
    <div class="hp-stat-body">
      <div class="hp-stat-val">{{ istatistikler().kartli }}</div>
      <div class="hp-stat-lbl">Kartlı</div>
    </div>
  </div>
</div>

<!-- ═══ TABLO ═══ -->
<div class="hp-table-wrap">
  <nz-table #tabloRef
            [nzData]="liste()"
            [nzTotal]="toplam()"
            [nzPageSize]="sayfaLimiti"
            [nzPageIndex]="mevcutSayfa"
            [nzFrontPagination]="false"
            [nzLoading]="yukleniyor()"
            [nzShowSizeChanger]="true"
            [nzPageSizeOptions]="[10, 20, 50]"
            (nzPageIndexChange)="sayfaDegisti($event)"
            (nzPageSizeChange)="limitDegisti($event)"
            nzSize="middle">
    <thead>
      <tr>
        <th nzWidth="50px" nzAlign="center">#</th>
        <th>Ad Soyad</th>
        <th nzWidth="130px">Sicil No</th>
        <th nzWidth="150px">Departman</th>
        <th nzWidth="140px">Ünvan</th>
        <th nzWidth="110px" nzAlign="center">Kart</th>
        <th nzWidth="90px" nzAlign="center">Durum</th>
        <th nzWidth="160px" nzAlign="center" nzRight>İşlemler</th>
      </tr>
    </thead>
    <tbody>
      @for (p of tabloRef.data; track p._id; let i = $index) {
        <tr>
          <td nzAlign="center" style="color:#bfbfbf;font-size:12px">
            {{ (mevcutSayfa - 1) * sayfaLimiti + i + 1 }}
          </td>
          <td>
            <div class="hp-ad-cell">
              <div class="hp-avatar" [style.background]="avatarRenk(p)">
                {{ avatarHarf(p) }}
              </div>
              <div>
                <div class="hp-ad-text">{{ p.ad }} {{ p.soyad }}</div>
                @if (p.gorev) {
                  <div class="hp-gorev-text">{{ p.gorev }}</div>
                }
              </div>
            </div>
          </td>
          <td><code class="hp-sicil">{{ p.sicilNo || '-' }}</code></td>
          <td>
            @if (p.departman) {
              <nz-tag nzColor="blue">{{ p.departman.departmanAdi }}</nz-tag>
            } @else {
              <span style="color:#bfbfbf">-</span>
            }
          </td>
          <td>{{ p.unvan || '-' }}</td>
          <td nzAlign="center">
            @if (p.kartUid) {
              <nz-badge nzStatus="success" [nzText]="kartKisa(p.kartUid)"
                        nz-tooltip [nzTooltipTitle]="p.kartUid" />
            } @else {
              <nz-badge nzStatus="default" nzText="Yok" />
            }
          </td>
          <td nzAlign="center">
            @if (p.aktif) {
              <nz-tag nzColor="success">Aktif</nz-tag>
            } @else {
              <nz-tag nzColor="default">Pasif</nz-tag>
            }
          </td>
          <td nzAlign="center" nzRight>
            <div class="hp-islem-btns">
              <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Detay"
                      (click)="detayAc(p)">
                <span nz-icon nzType="eye" style="color:#1677ff"></span>
              </button>
              <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Düzenle"
                      (click)="formAc(p)">
                <span nz-icon nzType="edit" style="color:#fa8c16"></span>
              </button>
              @if (p.kartUid) {
                <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Kart İptal"
                        nz-popconfirm nzPopconfirmTitle="Kart iptal edilsin mi?"
                        (nzOnConfirm)="kartIptalEt(p)">
                  <span nz-icon nzType="disconnect" style="color:#ff7a45"></span>
                </button>
              } @else {
                <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Kart Ata"
                        (click)="kartModalAc(p)">
                  <span nz-icon nzType="credit-card" style="color:#13c2c2"></span>
                </button>
              }
              <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Sil"
                      nz-popconfirm nzPopconfirmTitle="Personel kaydını silmek istediğinize emin misiniz?"
                      nzOkText="Evet, Sil" nzCancelText="İptal"
                      (nzOnConfirm)="personelSil(p)">
                <span nz-icon nzType="delete" style="color:#ff4d4f"></span>
              </button>
            </div>
          </td>
        </tr>
      } @empty {
        <tr>
          <td colspan="8" style="padding:48px 0">
            <nz-empty [nzNotFoundContent]="bosRef" />
            <ng-template #bosRef>
              <span style="color:#8c8c8c">
                {{ aramaMetni ? 'Aramanızla eşleşen personel bulunamadı' : 'Henüz personel eklenmemiş' }}
              </span>
            </ng-template>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
</div>

@if (!firmaId) {
  <nz-alert nzType="warning" nzShowIcon nzBanner
            nzMessage="Firma bağlantısı yapılmamış. Ayarlar sayfasından 'Bağlı Firma Kimliği' alanını doldurun."
            style="margin-top:16px; border-radius:10px" />
}

<!-- ═══ YENİ PERSONEL / DÜZENLE MODAL ═══ -->
<nz-modal [(nzVisible)]="formGorunur"
          [nzTitle]="formDuzenlemeModu ? 'Personel Düzenle' : 'Yeni Personel Ekle'"
          [nzWidth]="560"
          (nzOnCancel)="formGorunur = false"
          [nzOkText]="formDuzenlemeModu ? 'Güncelle' : 'Kaydet'"
          (nzOnOk)="formKaydet()"
          [nzOkLoading]="formKaydediliyor()"
          nzCentered>
  <ng-container *nzModalContent>
    <div class="hp-form-grid">
      <nz-form-item>
        <nz-form-label nzRequired>Ad</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="Adı" [(ngModel)]="form.ad" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzRequired>Soyad</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="Soyadı" [(ngModel)]="form.soyad" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>Sicil No</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="Sicil numarası" [(ngModel)]="form.sicilNo" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>TC Kimlik</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="TC Kimlik" [(ngModel)]="form.tcKimlik" maxlength="11" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>Departman</nz-form-label>
        <nz-form-control>
          <nz-select [(ngModel)]="form.departmanId" nzPlaceHolder="Departman seçin"
                     nzAllowClear style="width:100%">
            @for (d of departmanlar(); track d._id) {
              <nz-option [nzValue]="d._id" [nzLabel]="d.departmanAdi" />
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>Ünvan</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="Ünvan" [(ngModel)]="form.unvan" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="hp-form-full">
        <nz-form-label>Görev</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="Görev tanımı" [(ngModel)]="form.gorev" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>Telefon</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="05XX XXX XX XX" [(ngModel)]="form.telefon" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>E-posta</nz-form-label>
        <nz-form-control>
          <input nz-input placeholder="ornek@firma.com" [(ngModel)]="form.eposta" />
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-container>
</nz-modal>

<!-- ═══ KART ATAMA MODAL ═══ -->
<nz-modal [(nzVisible)]="kartModalGorunur"
          nzTitle="RFID Kart Atama"
          [nzWidth]="420"
          (nzOnCancel)="kartModalGorunur = false"
          nzOkText="Kart Ata"
          (nzOnOk)="kartAta()"
          [nzOkLoading]="kartKaydediliyor()"
          nzCentered>
  <ng-container *nzModalContent>
    @if (kartHedefPersonel; as p) {
      <div class="hp-kart-info">
        <div class="hp-avatar hp-avatar-lg" [style.background]="avatarRenk(p)">{{ avatarHarf(p) }}</div>
        <div>
          <div style="font-weight:600">{{ p.ad }} {{ p.soyad }}</div>
          <div style="font-size:12px;color:#8c8c8c">Sicil: {{ p.sicilNo || '-' }}</div>
        </div>
      </div>
      <nz-divider style="margin:16px 0" />
    }
    <nz-form-item>
      <nz-form-label nzRequired>Kart UID</nz-form-label>
      <nz-form-control>
        <nz-input-wrapper [nzPrefix]="kartIconRef">
          <input nz-input placeholder="Kartı okutun veya UID girin..."
                 [(ngModel)]="kartUidGirdi"
                 (keyup.enter)="kartAta()"
                 style="font-family:monospace;letter-spacing:1px" />
        </nz-input-wrapper>
        <ng-template #kartIconRef>
          <span nz-icon nzType="credit-card" style="color:#13c2c2"></span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-alert nzType="info" nzShowIcon [nzBanner]="true"
              nzMessage="RFID kartını okuyucuya okutun veya kart UID bilgisini manuel olarak girin."
              style="border-radius:8px;margin-top:8px" />

    @if (kartDinleniyor()) {
      <div class="hp-kart-dinle">
        <nz-spin nzSimple nzSize="small" />
        <span>Kart bekleniyor...</span>
      </div>
    }
  </ng-container>
</nz-modal>

<!-- ═══ DETAY MODAL ═══ -->
<nz-modal [nzVisible]="detayGorunur"
           nzTitle="Personel Detayı"
           [nzWidth]="480"
           [nzFooter]="null"
           (nzOnCancel)="detayGorunur = false">
  <ng-container *nzModalContent>
    @if (detayPersonel; as p) {
      <div class="hp-detay-profil">
        <div class="hp-avatar hp-avatar-xl" [style.background]="avatarRenk(p)">{{ avatarHarf(p) }}</div>
        <div>
          <h3 style="margin:0;font-size:18px;font-weight:700">{{ p.ad }} {{ p.soyad }}</h3>
          <div style="color:#8c8c8c;margin-top:2px">{{ p.unvan || p.gorev || '-' }}</div>
          <div style="display:flex;gap:6px;margin-top:8px;flex-wrap:wrap">
            @if (p.aktif) {
              <nz-tag nzColor="success">Aktif</nz-tag>
            } @else {
              <nz-tag nzColor="default">Pasif</nz-tag>
            }
            @if (p.kartUid) {
              <nz-tag nzColor="cyan">
                <span nz-icon nzType="credit-card"></span> Kartlı
              </nz-tag>
            }
            @if (p.departman) {
              <nz-tag nzColor="blue">{{ p.departman.departmanAdi }}</nz-tag>
            }
          </div>
        </div>
      </div>

      <nz-divider nzText="Kişisel Bilgiler" nzOrientation="left" />
      <nz-descriptions nzBordered nzSize="small" [nzColumn]="1">
        <nz-descriptions-item nzTitle="Sicil No">
          <code class="hp-sicil">{{ p.sicilNo || '-' }}</code>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="TC Kimlik">{{ p.tcKimlik || '-' }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Telefon">
          @if (p.telefon) {
            <a [href]="'tel:' + p.telefon" style="color:#1677ff">{{ p.telefon }}</a>
          } @else { - }
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="E-posta">
          @if (p.eposta) {
            <a [href]="'mailto:' + p.eposta" style="color:#1677ff">{{ p.eposta }}</a>
          } @else { - }
        </nz-descriptions-item>
      </nz-descriptions>

      <nz-divider nzText="İş Bilgileri" nzOrientation="left" />
      <nz-descriptions nzBordered nzSize="small" [nzColumn]="1">
        <nz-descriptions-item nzTitle="Departman">{{ p.departman?.departmanAdi || '-' }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Ünvan">{{ p.unvan || '-' }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Görev">{{ p.gorev || '-' }}</nz-descriptions-item>
      </nz-descriptions>

      <nz-divider nzText="Kart Bilgileri" nzOrientation="left" />
      <nz-descriptions nzBordered nzSize="small" [nzColumn]="1">
        <nz-descriptions-item nzTitle="Kart UID">
          @if (p.kartUid) {
            <code class="hp-sicil">{{ p.kartUid }}</code>
          } @else {
            <span style="color:#bfbfbf">Atanmamış</span>
          }
        </nz-descriptions-item>
        @if (p.kartAtanmaTarihi) {
          <nz-descriptions-item nzTitle="Atanma Tarihi">
            {{ p.kartAtanmaTarihi | date:'dd.MM.yyyy HH:mm' }}
          </nz-descriptions-item>
        }
      </nz-descriptions>

      <div style="display:flex;gap:10px;margin-top:24px;padding-top:16px;border-top:1px solid #f0f0f0">
        <button nz-button nzType="primary" (click)="detayGorunur = false; formAc(p)">
          <span nz-icon nzType="edit"></span> Düzenle
        </button>
        @if (!p.kartUid) {
          <button nz-button (click)="detayGorunur = false; kartModalAc(p)">
            <span nz-icon nzType="credit-card"></span> Kart Ata
          </button>
        }
      </div>
    }
  </ng-container>
</nz-modal>
